import {mapActions, mapState} from 'vuex'
import Helper from '@/utils/helper'
import * as types from '@/store/types'
import ClientCreateResponse from '@/app/service/api/model/client-create-response'

export default {
    name: 'Client',
    computed: {
        ...mapState({
            client: state => state.app.client,
            servicing: state => state.app.servicing
        })
    },
    data() {
        return {
            clientTimer: 0,
            clientKey: 0
        }
    },
    methods: {
        ...mapActions({
            appClientSet: types.APP.client.set,
            appServicingSet: types.APP.servicing.set
        })
    },
    beforeMount() {
        if (!Helper.isDefined(this.client)) {
            this.$service._setGuiLoading()
            this.$pageManager.showInit()
            this.$service._unsetGuiLoading()
        }

        if (Helper.isDefined(this.servicing)) {
            this.$service._setGuiLoading()
            this.$pageManager.showServicing()
            this.$service._unsetGuiLoading()
        }

        this.clientTimer = setInterval(() => {
            this.$service.getStatus(this.client.id).then((status) => {
                const id = this.client.id
                const number = this.client.number
                const beforePeoples = status.getBeforePeoples()
                const clientCreateResponse = new ClientCreateResponse({id, number, beforePeoples})
                const changed = status.getBeforePeoples() !== this.client.getBeforePeoples()
                this.appClientSet(clientCreateResponse)
                if (changed) {
                    this.clientKey++
                }
                if (Helper.isDefined(status.getIdServicing())) {
                    this.$service._setGuiLoading()
                    this.appServicingSet(status)
                    this.$pageManager.showServicing()
                    clearInterval(this.clientTimer)
                    this.$service._unsetGuiLoading()
                }
            }).catch((e) => {
                this.$service._catchError(e)
                clearInterval(this.clientTimer)
                this.$pageManager.showHome()
            })
        }, 5000)
    }
}
